module.exports = __webpack_public_path__ + "media/images/help/linkedin-Icon-0c54655ce478232eee3747bff621f6f3.png";